export default "__VITE_ASSET__ba7a036d__"